import type { ChannelRow } from '../api/channels';

function normalizeCategoryForKey(cat: string | null | undefined): string {
  if (cat == null || cat === '') return 'UNCATEGORIZED';
  const v = String(cat).trim();
  const upper = v.toUpperCase();
  if (upper === 'UNCATEGORIZED') return 'UNCATEGORIZED';
  return v;
}

export function getDuplicateRemovalStats(
  channels: ChannelRow[],
  key: 'name' | 'url',
  scope: 'all' | 'selected' | 'categories',
  selectedIdsSet: Set<number>,
): { removedCount: number; checkedCount: number; deleteIds: number[] } {
  const removedByGroup = new Map<string, ChannelRow[]>();

  for (const c of channels) {
    const id = Number(c.id);
    const keyVal = String((c && c[key]) ?? '').trim();
    if (!Number.isFinite(id)) continue;
    if (!keyVal) continue;

    if (scope === 'selected' && !selectedIdsSet.has(id)) continue;

    const groupKey =
      scope === 'categories' ? `${normalizeCategoryForKey(c.category)}||${keyVal}` : keyVal;

    if (!removedByGroup.has(groupKey)) removedByGroup.set(groupKey, []);
    removedByGroup.get(groupKey)!.push(c);
  }

  let removedCount = 0;
  let checkedCount = 0;
  const deleteIds: number[] = [];

  for (const [, rows] of removedByGroup.entries()) {
    rows.sort((a, b) => {
      const sa = Number(a.sort_order ?? 0);
      const sb = Number(b.sort_order ?? 0);
      if (sa !== sb) return sa - sb;
      return Number(a.id) - Number(b.id);
    });
    checkedCount += rows.length;
    if (rows.length > 1) {
      const del = rows.slice(1);
      removedCount += del.length;
      for (const d of del) deleteIds.push(Number(d.id));
    }
  }

  return { removedCount, checkedCount, deleteIds };
}
